<template>
  <div
    :style="{
      padding: '0px',
      margin: '14px',
      minHeight: '100px',
    }"
  >
    <a-row>
      <a-col :span="16">
        <div
          :style="{
            padding: '',
            margin: '24px 0px 24px 0',
            minHeight: '100px',
          }"
        >
          <a-row>
            <a-col :span="12">
              <div
                class="cardone"
                :style="{
                  background: '#fff',
                  minHeight: '100px',
                  padding: '0 10px',
                }"
              >
                <p class="text3">数据统计</p>
                <a-divider />
                <a-row>
                  <a-col :span="12">
                    <div
                      class=""
                      :style="{
                        background: '#f5f5f5',
                        minHeight: '110px',
                        padding: '10px',
                      }"
                    >
                      <p>会员统计</p>
                      <h1 style="color: #000">{{ members }}</h1>
                      <p>当前注册的会员数量</p>
                    </div>
                  </a-col>
                  <a-col :span="12">
                    <div
                      :style="{
                        margin: '0 0 0 8px',
                        background: '#f5f5f5',
                        minHeight: '110px',
                        padding: '10px',
                      }"
                    >
                      <p>销售额</p>
                      <h1>{{ sales }}</h1>
                      <p>当前销售总额</p>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-col>
            <a-col :span="12">
              <div
                class="cardtwo"
                :style="{
                  margin: '0 0px 0 14px',
                  background: '#fff',
                  minHeight: '100px',
                  padding: '0 10px',
                }"
              >
                <p class="text3">快速导航</p>
                <a-divider />
                <a-row>
                  <a-col :span="8">
                    <div
                      :style="{
                        background: '#f5f5f5',
                        minHeight: '80px',
                      }"
                    >
                      <h1 class="text">{{ currencyTotal }}</h1>
                    </div>
                    <p class="text1">代币套餐订单</p>
                  </a-col>
                  <a-col :span="8">
                    <div
                      :style="{
                        margin: '0 0 0 10px',
                        background: '#f5f5f5',
                        minHeight: '80px',
                      }"
                    >
                      <h1 class="text">{{ ticketsTotal }}</h1>
                    </div>
                    <p class="text1">门票套餐订单</p>
                  </a-col>
                  <a-col :span="8">
                    <div
                      :style="{
                        margin: '0 0 0 8px',
                        background: '#f5f5f5',
                        minHeight: '80px',
                      }"
                    >
                      <h1 class="text">{{ orderTotal }}</h1>
                    </div>
                    <p class="text1">已支付订单</p>
                  </a-col>
                </a-row>
              </div>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <homeEchatrsTwo></homeEchatrsTwo>
            </a-col>
          </a-row>
        </div>
      </a-col>
      <a-col :span="8">
        <div
          class="zhanneixin"
          :style="{
            padding: '24px',
            margin: '24px 0 24px 14px',
            background: '#fff',
            minHeight: '100px',
          }"
        >
          <h1 style="font-size: 16px">站内信</h1>

          <a-divider />
          <!--
          <a-row>
            <a-col :span="8"> 订单支付 </a-col>
            <a-col :span="4"> <a-badge count="未读" /> </a-col>
            <a-col :span="12"> 2021-3-14 00:00:00 </a-col>
          </a-row>
          <a-row>
            <a-col :span="8"> 订单支付 </a-col>
            <a-col :span="4">
              <a-badge
                count="已读"
                :number-style="{ backgroundColor: '#52c41a' }"
              />
            </a-col>
            <a-col :span="12"> 2021-3-14 00:00:00 </a-col>
          </a-row> -->
          <a-modal v-model="visible" title="消息" @ok="handleOk">
            <p>{{ mes }}</p>
          </a-modal>
          <a-table
            @change="handleTableChange"
            :columns="columns"
            :data-source="data"
            :showHeader="false"
            :pagination="pagination"
            :loading="loading"
          >
            <template slot="messageType" slot-scope="text, messageType">
              <a-tag
                @click="message(messageType)"
                v-if="messageType.readed === true"
                color="#87d068"
              >
                已读
              </a-tag>
              <a-tag v-else color="#f50" @click="message(messageType)">
                未读
              </a-tag>
            </template>
          </a-table>
        </div>
        <div
          class="xitong"
          :style="{
            padding: '24px',
            margin: '24px 0 10px 14px',
            background: '#fff',
            minHeight: '100px',
          }"
        >
          <p class="p">系统消息</p>

          <a-divider />
          <systemInformationFormTwo></systemInformationFormTwo>
        </div>

        <div style="display: flex; align-items: center;float: left;margin-left: 15px;">
<!--          <div style="margin-left: 20px" @click="downloadCodeImg">
            门店二维码
          </div>-->
          <p @click="downloadCodeImg">门店二维码:</p>
          <img
            @click="downloadCodeImg"
            :src="img"
            alt=""
            style="width: 170px; height: 170px; margin-left: 10px"
          />
        </div>

        <div style="display: flex; align-items: center;float: left;margin-left: 31px;">
<!--          <div style="margin-left: 20px" @click="downloadCodeImgs">
            门店小程序码
          </div>-->
          <p @click="downloadCodeImg">门店小程序:</p>
          <img
            @click="downloadCodeImgs"
            :src="imgs"
            alt=""
            style="width: 170px; height: 170px; margin-left: 10px"
          />
        </div>
        <div style="clear: both;"></div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {
  storeMainSales,
  storeMembers,
  storeMainLetter,
  storeMainOrder,
  storeMainMessage,
  createCode,
  createCodes,
} from "@/api/storeApi.js";
import systemInformationFormTwo from "./systemInformationFormTwo.vue";
import homeEchatrsTwo from "./homeEchatrsTwo.vue";
const columns = [
  {
    title: "ma",
    dataIndex: "messageTitle",
    scopedSlots: { customRender: "name" },
  },
  {
    dataIndex: "readed",
    scopedSlots: { customRender: "messageType" },
  },
  {
    dataIndex: "createTime",
    scopedSlots: { customRender: "createTime" },
  },
];

const data = [
  {
    key: "1",
    name: "John Brown",
    age: 32,
    address: "New York No. 1 Lake Park",
    tags: ["nice", "developer"],
  },
  {
    key: "2",
    name: "Jim Green",
    age: 42,
    address: "London No. 1 Lake Park",
    tags: ["loser"],
  },
  {
    key: "3",
    name: "Joe Black",
    age: 32,
    address: "Sidney No. 1 Lake Park",
    tags: ["cool", "teacher"],
  },
];
export default {
  components: {
    systemInformationFormTwo,
    homeEchatrsTwo,
  },
  data() {
    return {
      data: {},
      mes: "",
      img: "",
      imgs: "",
      readed: "",
      objId: "",
      visible: false,
      columns,
      mendian: "",
      huiyuan: "",
      sales: "", // 销售额
      members: "", // 会员统计
      currencyTotal: "",
      orderTotal: "",
      ticketsTotal: "",
    };
  },
  mounted() {
    this.getStoreMainSales();
    this.getStoreMembers();
    this.getStoreMainLetter();
    this.getStoreMainOrder();
    this.getCreateCode();
    this.getCreateCodes();
  },
  methods: {
    // 下载图片
    downloadCodeImg() {
      console.log("下载图片");
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = this.img;
      a.click();
    },

    downloadCodeImgs() {
      console.log("下载图片");
      var a = document.createElement("a");
      a.download = name || "pic";
      // 设置图片地址
      a.href = this.imgs;
      a.click();
    },

    getCreateCode() {
      createCode().then((res) => {
        console.log(res, "res---------------");
        this.img = res.data;
      });
    },
    getCreateCodes() {
      createCodes().then((res) => {
        console.log(res, "res---------------");
        this.imgs = res.data;
      });
    },
    getStoreMainSales() {
      storeMainSales().then((res) => {
        this.sales = res.data;
        console.log(res);
      });
    },
    message(row) {
      this.visible = true;
      this.mes = row.messageRecord;
      this.readed = row.readed;
      this.objId = row.objId;
    },
    getStoreMembers() {
      storeMembers().then((res) => {
        this.members = res.data;
      });
    },
    getStoreMainLetter() {
      storeMainLetter(5, 1).then((res) => {
        this.data = res.data;
      });
    },
    getStoreMainOrder() {
      storeMainOrder().then((res) => {
        this.currencyTotal = res.data.currencyTotal;
        this.orderTotal = res.data.orderTotal;
        this.ticketsTotal = res.data.ticketsTotal;
      });
    },
    handleOk() {
      this.visible = false;
      getStoreMainLetter(this.objId).then((res) => {
        this.getMainTableTwolInfo();
        message.success("已读消息");
      });
    },
  },
};
</script>

<style>
.xitong {
  height: 393px;
}
.cardone {
  height: 236px;
}
.cardtwo {
  height: 236px;
}
.text {
  line-height: 80px;
  text-align: center;
}
.text1 {
  font-weight: 500;
  color: #000;
  font-size: 16px;
  text-align: center;
}
h1 {
  font-size: 28px;
  color: #666666;
}
.text3 {
  position: relative;
  top: 10px;
  color: #000;
  font-size: 16px;
}
.p {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeContentTwo.vue